/*
 * ============================================================================
 * Subscribe & Save Buy Box  —  RYZIN product buy box (AG1 / IM8 style)
 * ----------------------------------------------------------------------------
 * INSTANCE-SAFE: one BBX object per section root. Every DOM lookup is scoped to
 * the root (root.querySelector / root.querySelectorAll). No getElementById, no
 * document-global queries. Multiple v2 boxes coexist on one page.
 *
 * Model: FREE per-flavor quantity. Each flavor has its own stepper (0..N); the
 * order total is just the sum — no fixed roll-count lock.
 *
 * Preserves the verified subscription contract:
 *   - subscribe is the default when its option is .active
 *   - real % derived live: 1 - (subPrice / oneRollPrice)  (never hardcoded)
 *   - addToCart attaches item.selling_plan = <active cadence plan id> ONLY on
 *     the subscribe path; one-time sends no selling_plan
 *   - cadence selector drives WHICH plan id is attached (Monthly/2mo/3mo)
 * ============================================================================
 */
(function () {
  'use strict';

  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function BBX(root) {
    this.root = root;
    this.el = {};
    this.state = {
      purchaseType: 'onetime',
      flavorQuantities: {},      // { variantId: qty }  (free, no cap)
      oneRollPrice: 0,           // cents
      pouchesPerRoll: 75,
      cansPerRoll: 5,
      freeShipCents: 6000,
      cadencePlanId: null,
      cadenceSubPrice: 0,        // cents (active cadence, per roll)
      defaultSellingPlanId: null,
      hasSub: false
    };
  }

  BBX.prototype.init = function () {
    this.cacheDom();
    this.loadConfig();
    this.loadSellingPlan();
    this.bindEvents();
    this.syncDefaults();
    this.render();
    this.updateGalleryScroll();
    if (document.readyState !== 'complete') {
      var self = this;
      window.addEventListener('load', function () { self.updateGalleryScroll(); });
    }
  };

  BBX.prototype.cacheDom = function () {
    var r = this.root;
    var $ = function (s) { return r.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(r.querySelectorAll(s)); };
    this.el = {
      root: r,
      purchaseOptions: $$('[data-bbx-purchase]'),
      cadenceGroup: $('[data-bbx-cadence-group]'),
      cadenceOptions: $$('[data-bbx-cadence]'),
      flavorEls: $$('[data-bbx-flavor]'),
      slides: $$('[data-bbx-slide]'),
      thumbs: $$('[data-bbx-thumb]'),
      mediaRail: $('.bbx__media-rail'),
      mediaThumbs: $('.bbx__media-thumbs'),
      accTriggers: $$('[data-bbx-acc-trigger]'),
      flavorHelp: $('[data-bbx-flavor-help]'),
      currentPrice: $('[data-bbx-current-price]'),
      comparePrice: $('[data-bbx-compare-price]'),
      perUnit: $('[data-bbx-per-unit]'),
      subPriceOut: $('[data-bbx-sub-price]'),
      oneTimeOut: $('[data-bbx-onetime-price]'),
      shipText: $('[data-bbx-ship-text]'),
      shipFill: $('[data-bbx-ship-fill]'),
      addBtn: $('[data-bbx-add]'),
      subBenefits: $('[data-bbx-sub-benefits]')
    };
  };

  BBX.prototype.loadConfig = function () {
    var d = this.root.dataset;
    this.state.oneRollPrice = parseInt(d.onetimePrice, 10) || 0;
    this.state.pouchesPerRoll = parseInt(d.pouchesPerRoll, 10) || 75;
    this.state.cansPerRoll = parseInt(d.cansPerRoll, 10) || 5;
    this.state.freeShipCents = parseInt(d.freeShip, 10) || 6000;
    this.state.hasSub = !!d.sellingPlanId;
    this.state.defaultSellingPlanId = d.sellingPlanId ? parseInt(d.sellingPlanId, 10) : null;
  };

  BBX.prototype.findActive = function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('active')) return list[i];
    }
    return null;
  };

  // Sync purchaseType to the active option (root-scoped) + read active cadence's real plan.
  BBX.prototype.loadSellingPlan = function () {
    var s = this.state, el = this.el;
    var activeCad = this.findActive(el.cadenceOptions) || el.cadenceOptions[0];
    if (activeCad) {
      s.cadencePlanId = parseInt(activeCad.dataset.sellingPlanId, 10) || null;
      s.cadenceSubPrice = parseInt(activeCad.dataset.subPrice, 10) || 0;
    } else {
      s.cadencePlanId = s.defaultSellingPlanId;
      s.cadenceSubPrice = parseInt(this.root.dataset.subPricePerRoll, 10) || 0;
    }
    var activePur = this.findActive(el.purchaseOptions);
    if (activePur) s.purchaseType = activePur.dataset.bbxPurchase;
  };

  BBX.prototype.firstAvailableFlavor = function () {
    for (var i = 0; i < this.el.flavorEls.length; i++) {
      if (this.el.flavorEls[i].dataset.available === 'true') return this.el.flavorEls[i];
    }
    return this.el.flavorEls[0] || null;
  };

  BBX.prototype.syncDefaults = function () {
    // Flavors start empty (free per-flavor quantity). Kick the active gallery
    // video into muted autoplay (some browsers need the muted property + play()).
    var v = this.root.querySelector('.bbx__media-slide.is-active video');
    if (v) { v.muted = true; var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
  };

  BBX.prototype.bindEvents = function () {
    var self = this;
    this.el.purchaseOptions.forEach(function (opt) {
      opt.addEventListener('click', function () { self.onPurchaseType(opt); });
    });
    this.el.cadenceOptions.forEach(function (opt) {
      opt.addEventListener('click', function () { self.onCadence(opt); });
    });
    this.el.flavorEls.forEach(function (card) {
      if (card.dataset.available !== 'true') return;
      var minus = card.querySelector('[data-bbx-step="-1"]');
      var plus = card.querySelector('[data-bbx-step="1"]');
      if (minus) minus.addEventListener('click', function (e) { e.stopPropagation(); self.adjustFlavor(card, -1); });
      if (plus) plus.addEventListener('click', function (e) { e.stopPropagation(); self.adjustFlavor(card, 1); });
    });
    this.el.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.onThumb(t); });
    });
    this.el.accTriggers.forEach(function (btn) {
      btn.addEventListener('click', function () { self.toggleAcc(btn); });
    });
    window.addEventListener('resize', function () { self.updateGalleryScroll(); });
    if (this.el.addBtn) this.el.addBtn.addEventListener('click', function () { self.addToCart(); });
  };

  /* ---- handlers ---- */

  BBX.prototype.onPurchaseType = function (opt) {
    this.state.purchaseType = opt.dataset.bbxPurchase;
    this.setActive(this.el.purchaseOptions, opt);
    var isSub = this.state.purchaseType === 'subscription';
    if (this.el.cadenceGroup) this.el.cadenceGroup.classList.toggle('bbx--hidden', !isSub);
    if (this.el.subBenefits) this.el.subBenefits.classList.toggle('active', isSub);
    this.render();
  };

  BBX.prototype.onCadence = function (opt) {
    this.state.cadencePlanId = parseInt(opt.dataset.sellingPlanId, 10) || null;
    this.state.cadenceSubPrice = parseInt(opt.dataset.subPrice, 10) || 0;
    this.setActive(this.el.cadenceOptions, opt);
    this.render();
  };

  BBX.prototype.adjustFlavor = function (card, delta) {
    var id = card.dataset.variantId;
    var cur = this.state.flavorQuantities[id] || 0;
    var next = cur + delta;
    if (next < 0) next = 0;
    if (next <= 0) { delete this.state.flavorQuantities[id]; next = 0; }
    else { this.state.flavorQuantities[id] = next; }
    var countEl = card.querySelector('[data-bbx-count]');
    if (countEl) countEl.textContent = String(next);
    card.classList.toggle('is-selected', next > 0);
    this.render();
  };

  BBX.prototype.onThumb = function (t) {
    var idx = t.dataset.index;
    this.el.slides.forEach(function (s) {
      var on = s.dataset.bbxSlide === idx;
      s.classList.toggle('is-active', on);
      var v = s.querySelector('video');
      if (v) { if (on) { v.play().catch(function () {}); } else { v.pause(); } }
    });
    this.el.thumbs.forEach(function (n) { n.classList.toggle('is-active', n === t); });
  };

  // Show the scroll cue (fade) only when the thumbnail rail actually overflows its capped height.
  BBX.prototype.updateGalleryScroll = function () {
    var rail = this.el.mediaRail, thumbs = this.el.mediaThumbs;
    if (!rail || !thumbs) return;
    rail.classList.toggle('is-scrollable', thumbs.scrollHeight > thumbs.clientHeight + 2);
  };

  BBX.prototype.toggleAcc = function (btn) {
    var item = btn.closest('[data-bbx-acc]');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  /* ---- render ---- */

  BBX.prototype.totalQty = function () {
    var t = 0;
    for (var id in this.state.flavorQuantities) t += this.state.flavorQuantities[id];
    return t;
  };

  BBX.prototype.render = function () {
    this.updatePricing();
    this.updateShipBar();
    this.updateSteppers();
    this.updateHelp();
    this.updateAddState();
  };

  BBX.prototype.updatePricing = function () {
    var s = this.state, el = this.el;
    var qty = this.totalQty();
    var effQty = qty > 0 ? qty : 1;           // show 1-roll baseline before anything is added
    var fullTotal = s.oneRollPrice * effQty;
    var shown = fullTotal, compare = null;

    if (s.purchaseType === 'subscription' && s.oneRollPrice > 0) {
      var realPct = 1 - (s.cadenceSubPrice / s.oneRollPrice);
      shown = Math.round(fullTotal * (1 - realPct));  // == cadenceSubPrice * effQty
      compare = fullTotal;
    }
    var perRoll = Math.round(shown / effQty);
    var perPouch = Math.round(perRoll / s.pouchesPerRoll);

    if (el.currentPrice) { el.currentPrice.textContent = money(shown); el.currentPrice.dataset.price = shown; }
    if (el.comparePrice) {
      if (compare && compare > shown) { el.comparePrice.hidden = false; el.comparePrice.textContent = money(compare); }
      else { el.comparePrice.hidden = true; el.comparePrice.textContent = ''; }
    }
    if (el.perUnit) el.perUnit.textContent = money(perRoll) + '/roll · ' + money(perPouch) + '/pouch';
    if (el.subPriceOut) el.subPriceOut.textContent = money(s.cadenceSubPrice) + '/roll';
    if (el.oneTimeOut) el.oneTimeOut.textContent = money(s.oneRollPrice) + '/roll';
  };

  BBX.prototype.updateShipBar = function () {
    var s = this.state, el = this.el;
    if (!el.shipText || !el.shipFill) return;
    var unit = (s.purchaseType === 'subscription') ? s.cadenceSubPrice : s.oneRollPrice;
    var total = unit * this.totalQty();
    var pct = Math.min(100, Math.round(total / s.freeShipCents * 100));
    el.shipFill.style.width = pct + '%';
    if (total >= s.freeShipCents) {
      el.shipText.textContent = '✓ You’ve unlocked FREE shipping';
      el.shipText.classList.add('is-unlocked');
    } else {
      el.shipText.textContent = money(s.freeShipCents - total) + ' away from FREE shipping';
      el.shipText.classList.remove('is-unlocked');
    }
  };

  BBX.prototype.updateSteppers = function () {
    this.el.flavorEls.forEach(function (card) {
      if (card.dataset.available !== 'true') return;
      var minus = card.querySelector('[data-bbx-step="-1"]');
      var countEl = card.querySelector('[data-bbx-count]');
      var qty = countEl ? (parseInt(countEl.textContent, 10) || 0) : 0;
      if (minus) minus.disabled = qty <= 0;   // no upper cap — plus is always enabled
    });
  };

  BBX.prototype.updateHelp = function () {
    var el = this.el, s = this.state; if (!el.flavorHelp) return;
    var total = this.totalQty();
    if (total > 0) {
      var cans = total * s.cansPerRoll;
      var pouches = total * s.pouchesPerRoll;
      el.flavorHelp.textContent = '✓ ' + total + ' roll' + (total > 1 ? 's' : '') +
        ' · ' + cans + ' cans · ' + pouches + ' pouches in your order';
    } else {
      el.flavorHelp.textContent = 'Add the flavors you want — each roll is ' +
        s.cansPerRoll + ' cans (' + s.pouchesPerRoll + ' pouches)';
    }
  };

  BBX.prototype.enabledLabel = function () {
    var btn = this.el.addBtn;
    var typed = (this.state.purchaseType === 'subscription')
      ? btn.dataset.labelEnabledSub
      : btn.dataset.labelEnabledOnetime;
    return typed || btn.dataset.labelEnabled || 'Add to Cart';
  };

  BBX.prototype.updateAddState = function () {
    var btn = this.el.addBtn;
    if (!btn) return;
    var ready = this.totalQty() >= 1;
    btn.disabled = !ready;
    btn.textContent = ready ? this.enabledLabel() : (btn.dataset.labelDisabled || 'Select your flavors');
  };

  /* ---- cart ---- */

  // Subscription apps (Appstle) monkey-patch window.fetch and strip the
  // selling_plan from /cart/add.js — silently turning Subscribe & Save into a
  // one-time purchase at full price. Grab a pristine fetch from a hidden
  // same-origin iframe so our add request bypasses that patch. Cached for the
  // page's life (we redirect to /cart on success). Falls back to window.fetch.
  BBX.prototype.nativeFetch = function () {
    if (this._nativeFetch) return this._nativeFetch;
    try {
      var frame = document.createElement('iframe');
      frame.setAttribute('aria-hidden', 'true');
      frame.style.display = 'none';
      document.body.appendChild(frame);
      if (frame.contentWindow && typeof frame.contentWindow.fetch === 'function') {
        this._nativeFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
        return this._nativeFetch;
      }
    } catch (e) {}
    this._nativeFetch = window.fetch.bind(window);
    return this._nativeFetch;
  };

  BBX.prototype.addToCart = function () {
    var self = this, s = this.state, btn = this.el.addBtn;
    var total = this.totalQty();
    if (total < 1) return;

    var items = [];
    // Per-line pack contents. Quantity (handled by Shopify) = number of rolls of THIS flavor,
    // so we deliberately do NOT stamp an order-wide roll total on each line (that read as "2 rolls of each").
    var packDesc = s.cansPerRoll + ' cans · ' + s.pouchesPerRoll + ' pouches';
    for (var id in s.flavorQuantities) {
      var qty = s.flavorQuantities[id];
      if (qty <= 0) continue;
      var item = { id: id, quantity: qty, properties: { 'Each roll': packDesc } };
      if (s.purchaseType === 'subscription' && s.cadencePlanId) {
        item.selling_plan = s.cadencePlanId; // active cadence plan id
      }
      items.push(item);
    }
    if (!items.length) return;

    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    // Absolute URL required: the iframe's native fetch resolves relative paths
    // against about:blank, not the storefront. Respect Shopify locale root.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartAddUrl = window.location.origin + root + 'cart/add.js';

    this.nativeFetch()(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { if (!res.ok) { return res.json().then(function (e) { throw e; }); } return res.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[BBX] add to cart failed', err);
        if (btn) { btn.disabled = false; btn.textContent = self.enabledLabel(); }
        alert((err && err.description) ? err.description : 'Sorry, something went wrong adding to cart.');
      });
  };

  /* ---- utils ---- */

  BBX.prototype.setActive = function (list, active) {
    list.forEach(function (n) { n.classList.toggle('active', n === active); });
  };

  /* ---- boot (multi-instance + theme-editor safe) ---- */

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-section-type="subscribe-save-buybox"]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__bbx) return;
      root.__bbx = new BBX(root);
      root.__bbx.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
